import React from 'react'

import { useLocation } from 'react-router-dom'
import queryString from 'query-string'

import AdvertiserNavbar from '../AdvertiserNavBar/AdvertiserNavBar'
import AffiliateComparisonReport from '../../Reports/AffiliateComparisonReport/AffiliateComparisonReport'

const AdvertiserAffiliateComparisonReport = ({ showSystemMessage }) => {

    const location = useLocation()
    let urlParams = queryString.parse(location.search)

    return (
        <div>
            <div className="page-header d-flex align-items-center">
                <h1 className="mb-h1">Reports</h1>
                <div className="ml-5">
                    <AdvertiserNavbar advertiserId={urlParams.advertiserId} showSystemMessage={showSystemMessage} />
                </div>
            </div>
            <AffiliateComparisonReport advertiserId={urlParams.advertiserId} type="advertiser" showSystemMessage={showSystemMessage} />
        </div>
    )
}

export default AdvertiserAffiliateComparisonReport
